var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteamLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.05 91.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.45,0A45.6,45.6,0,0,0,0,42l24.44,10.1a12.89,12.89,0,0,1,7.27-2.24l.72,0L43.3,34.07v-.22a17.2,17.2,0,1,1,17.2,17.2h-.39L44.6,62.11c0,.2,0,.4,0,.61a12.91,12.91,0,0,1-25.57,2.54L1.57,58A45.6,45.6,0,1,0,45.45,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.58,69.2,23,66.88a9.68,9.68,0,1,0,5.3-13.24L34.07,56A7.13,7.13,0,1,1,28.58,69.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72,33.85A11.47,11.47,0,1,0,60.5,45.31,11.48,11.48,0,0,0,72,33.85Zm-20,0a8.61,8.61,0,1,1,8.6,8.61A8.61,8.61,0,0,1,51.91,33.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamLogoWhite);
export default __webpack_public_path__ + "static/media/steam-logo-white.ca8355b704ed2e89e618e155bfcc62c1.svg";
export { ForwardRef as ReactComponent };